export enum ErrorCode {
    NOT_AUTHENTICATED = "Não autenticado",
    FORBIDDEN = "Usuário permissão",
    INVALID_TENANT = "Tenant inválido",
    INVALID_REQUEST = "Requisição inválida",
    NOT_FOUND = "Não encontrada",
    ZABBIX_LOGIN_FAILED = "Falha ao autenticar no Zabbix",
    NOT_METRO_USER = "API disponível somente para usuários metro"
}

